/* ========================== */  
/* ========= import ========= */  
/* ========================== */  

/* ====== React ====== */
// import React from "react"
/* ====== CSS ====== */
import styled from 'styled-components';
/* ====== Component Js/Jsx ====== */
import { assets } from '03CommonApiParts/Configuration';
import { InputErrorMessage } from '02CommonUiParts/TableParts/InputErrorMessage';
/* ========================== */  
/* ========= Styles ========= */  
/* ========================== */  

/* ====== Styled Components ====== */
/* ------　インプットフィールド ------*/
const Sinput = styled.input`//インプット
    height:30px;
    width:125px;
    padding: 0 0 0 5px;                                            
    /* margin: -3px; */
    color: black;
    border-radius:3px;
    border: ${ props => props.readOnly ? 'none' : `solid 1px ${assets().color.border}`};
    appearance: ${props => props.readOnly ? 'none': '' };
    font: inherit;
    background-color:${props => props.readOnly ? 'transparent' : props.isDirty ? assets().color.lightYellow : 'white'};
    &:disabled{
        opacity:1;
        background-color:${props => props.readOnly ? 'transparent' : assets().color.disabled  };
    };
    &:read-only{
        background-color:transparent;
        pointer-events:none;
        border: none;
    }
    &:read-only ::-webkit-calendar-picker-indicator {
        display: none;
    }

`;
const SlabelSelectTitle = styled.label`//インプットタイトルラベル
    margin-right: 6px;
`;
const SinputBox = styled.div`//インプット小枠
    position: relative;
    border-radius: 3px;
    /* display: flex; */
    align-items: center;
    & ${Sinput}:focus{
        outline: solid 1.5px ${assets().color.focusOutline};
    };
`;

/* ========================== */  
/* ========== Main ========== */  
/* ========================== */ 
export const TableDateField = (props) => {
    /* ========================== */  
    /* ========== variables ========== */  
    /* ========================== */  
    const { id, errorMessage, value, defaultValue, label, maxLength, pattern, onChange, type, register, disabled, readOnly, boxStyle, isDirty} = props;
    /* ========================== */  
    /* ====== Start Render ====== */  
    /* ========================== */  
    return (
        <>
            <SinputBox style={boxStyle}>
                {label ?
                    <SlabelSelectTitle className='baseText' style={{fontSize:assets().size.baseText}}>{label} :</SlabelSelectTitle>
                :''}
                <Sinput
                    disabled={disabled}
                    readOnly={readOnly}
                    id={id}
                    name={id}
                    max={type === 'date' ? '9999-12-31':'9999-12-31T23:59'}
                    isDirty={isDirty}
                    defaultValue={defaultValue}
                    value={value}
                    maxLength={maxLength}
                    pattern={pattern}
                    onChange={onChange}
                    type={type}
                    placeholder=' '
                    autoComplete='off'
                    {...register}
                    className='inputText' 
                    style={{fontSize:assets().size.baseText,height:assets().size.inputHeight}}
                />
                {errorMessage ? <InputErrorMessage errorMessage={errorMessage}/> :'' }
            </SinputBox>
        </>
    );
};

